export { CommonQuestionsPage } from "./CommonQuestionsPage";
